import React from 'react';

export const patientSettingsConfig = [
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-patients/add',
        component: React.lazy(() => import('./NewPatient')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-patients/edit',
        component: React.lazy(() => import('./PatientTabs')),
      },
    ],
  },
 
];